import type { AgentApiJobSourcesService, JobSourceServiceType } from '@/types/serializers';
import { SERVICES } from '../constants/services';

// constants/services.ts の type: 'multi' が「同名グループに複数の取り込み方法がある」ソース
export function isGroupSourceType(sourceType: string): boolean {
  return SERVICES.some((s) => s.sourceType === sourceType && s.type === 'multi');
}

export function findServiceEntry(sourceType: string) {
  return SERVICES.find((s) => s.sourceType === sourceType);
}

export function resolveServiceDisplayName(
  sourceType: string,
  service: AgentApiJobSourcesService
): string {
  const entry = findServiceEntry(sourceType);
  // グループ代表と実サービスで source_type が重なるため、単体サービスのときだけ定数の表示名を使う
  return entry?.type === 'auth' ? entry.name : service.name;
}

// グループ代表の表示名と部分一致するサービスを集める
export function findGroupServices(
  services: AgentApiJobSourcesService[],
  groupName: string
): AgentApiJobSourcesService[] {
  return services.filter(
    (service) =>
      // 空 name のサービス（source_name 未定義）が任意のグループに誤混入するのを防ぐ
      service.name !== '' && (service.name.includes(groupName) || groupName.includes(service.name))
  );
}

export function listPathFor(
  serviceType?: JobSourceServiceType
): '/agent/linked_accounts' | '/agent/linked_accounts/shared' {
  return serviceType === 'database' ? '/agent/linked_accounts/shared' : '/agent/linked_accounts';
}
